import { spacingMapper } from 'helpers/mappers/spacingMapper';
import { Container } from 'ui/components/4-habitats/Container';
import { RichText } from 'ui/components/1-atoms/RichText';

export const RichTextEditorFeature: React.FC<Content.RichTextEditor> = ({ content }) => {
	const { spacing } = content?.properties ?? {};

	return (
		<Container section width="sm" spacingBottom={spacing ? spacingMapper(spacing) : 'sm'}>
			<RichText {...content?.properties} />
		</Container>
	);
};
